// NOTE: While using the Realex client library, we have to follow two step process
// Step 1 - Initialize the target environment i.e Sandbox/Development/Production etc
// Step 2 - Initialize how the HPP will be displayed i.e Embedded/Lightbox/FullPageRedirect
const init = (realexEndPointUri, paymentResponseUri, paymentRequestAsJson) => {
    // Initialize Global Payments
    RealexHpp.setHppUrl(realexEndPointUri);
    if(process.env.VUE_APP_REALEX_PAYMENT_IMPLEMENTATION_TYPE === "LightBox"){
        RealexHpp.lightbox.init("", paymentResponseUri, paymentRequestAsJson);
    }
    else if(process.env.VUE_APP_REALEX_PAYMENT_IMPLEMENTATION_TYPE === "FullPageRedirect"){
        RealexHpp.redirect.init("", paymentResponseUri, paymentRequestAsJson);
    }
    else{
        throw 'Not supported payment implementation type' + process.env.VUE_APP_REALEX_PAYMENT_IMPLEMENTATION_TYPE;
    }
};
export default { init };